module.exports = __webpack_public_path__ + "static/img/img18.c3fd96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img18.png
// module id = UXtf
// module chunks = 1